import React from "react";
import { Link } from "react-router-dom";
import "./ExchangePolicyPage.css";

// Exchange Policy Icons
function ShieldIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}

function PackageIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/>
      <path d="M12 22V12"/>
      <path d="M2 7l10 5 10-5"/>
    </svg>
  );
}

function RotateCcwIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="1,4 1,10 7,10"/>
      <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
    </svg>
  );
}

function ClockIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <polyline points="12,6 12,12 16,14"/>
    </svg>
  );
}

function CheckCircleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22,4 12,14.01 9,11.01"/>
    </svg>
  );
}

function TruckIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="3" width="15" height="13"/>
      <polygon points="16,8 20,8 23,11 23,16 16,16"/>
      <circle cx="5.5" cy="18.5" r="2.5"/>
      <circle cx="18.5" cy="18.5" r="2.5"/>
    </svg>
  );
}

function CameraIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
      <circle cx="12" cy="13" r="4"/>
    </svg>
  );
}

function AlertTriangleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  );
}

function HeartIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

export default function ExchangePolicyPage() {
  return (
    <div className="mariamly-exchange-policy-page">
      {/* Banner Section */}
      <div className="policy-banner">
        <div className="policy-banner-content">
          <h1 className="policy-banner-title">Exchange Policy</h1>
          <div className="policy-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Exchange Policy</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="policy-content">
        {/* Introduction Section */}
        <div className="policy-intro">
          <div className="intro-content">
            <h2>Exchange Policy – Mariamly Luxe</h2>
            <p className="intro-lead">
              At Mariamly Luxe, your satisfaction is our priority. We carefully inspect every order before shipping to ensure it arrives in perfect condition. However, if there is any issue with your purchase, we are here to help.
            </p>
          </div>
          <div className="intro-image">
            <div className="image-placeholder">
              <RotateCcwIcon size={48} color="#fff" />
            </div>
          </div>
        </div>

        {/* Eligibility Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <ClockIcon size={40} />
            </div>
            <h3>Eligibility</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <ClockIcon size={24} />
                <p>Requests for refunds or exchanges must be made within 3 days of receiving your order.</p>
              </div>
              <div className="policy-point">
                <PackageIcon size={24} />
                <p>Items must be unused, unopened, and in their original packaging.</p>
              </div>
              <div className="policy-point">
                <ShieldIcon size={24} />
                <p>For hygiene and safety reasons, opened or used cosmetics cannot be returned or refunded.</p>
              </div>
              <div className="policy-point">
                <CameraIcon size={24} />
                <p>Photographic or video proof are required to confirm the item's condition.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Refunds Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <ShieldIcon size={40} />
            </div>
            <h3>Refunds</h3>
          </div>
          <div className="section-content">
            <p className="section-intro">Refunds are only available if the item is:</p>
            <div className="policy-points">
              <div className="policy-point">
                <AlertTriangleIcon size={24} />
                <p>Damaged, defective, or incorrect upon arrival.</p>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <p>Approved refunds will be issued as store credits to use on your next order.</p>
              </div>
              <div className="policy-point">
                <PackageIcon size={24} />
                <p>Refunds to the original payment method are available only if the product was faulty, damaged, or incorrect.</p>
              </div>
              <div className="policy-point">
                <TruckIcon size={24} />
                <p>Shipping costs are non-refundable and will be deducted from the refunded amount unless the error was ours.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Exchanges Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <RotateCcwIcon size={40} />
            </div>
            <h3>Exchanges</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <PackageIcon size={24} />
                <p>Exchanges are accepted for unopened, unused items in their original packaging.</p>
              </div>
              <div className="policy-point">
                <TruckIcon size={24} />
                <p>Customers are responsible for covering the shipping costs for exchanges, unless the item was damaged, faulty, or incorrect.</p>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <p>If you receive a damaged or incorrect item, Mariamly Luxe will cover the exchange shipping fees.</p>
              </div>
            </div>
          </div>
        </div>

        {/* How to Request Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <HeartIcon size={40} />
            </div>
            <h3>How to Request a Refund or Exchange</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <span className="step-number">1</span>
                <div className="point-content">
                  Contact our customer service with your order number and details.
                </div>
              </div>
              <div className="policy-point">
                <span className="step-number">2</span>
                <div className="point-content">
                  Provide photos or video proof if the item is damaged, defective, or incorrect.
                </div>
              </div>
              <div className="policy-point">
                <span className="step-number">3</span>
                <div className="point-content">
                  Our team will review your request and guide you through the next steps.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Notes Section */}
        <div className="policy-section important-notes">
          <div className="section-header">
            <div className="section-icon">
              <AlertTriangleIcon size={40} />
            </div>
            <h3>Important Notes</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <AlertTriangleIcon size={24} />
                <p>Final sale and promotional items cannot be returned or exchanged.</p>
              </div>
              <div className="policy-point">
                <ShieldIcon size={24} />
                <p>Mariamly Luxe reserves the right to deny a return or exchange if the item does not meet policy requirements.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Satisfaction Notice */}
        <div className="satisfaction-notice">
          <div className="notice-content">
            <div className="notice-icon">
              <HeartIcon size={32} />
            </div>
            <div className="notice-text">
              <h4>✨ At Mariamly Luxe, we strive to make every shopping experience feel luxurious, safe, and worry-free.</h4>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="contact-section">
          <div className="contact-content">
            <h3>Questions About Our Exchange Policy?</h3>
            <p>
              If you have any questions about our exchange policy or need assistance with a return or exchange, our customer service team is here to help.
            </p>
            <div className="contact-buttons">
              <Link to="/contact" className="contact-button primary">
                <HeartIcon size={20} />
                <span>Contact Us</span>
              </Link>
              <Link to="/shop" className="contact-button secondary">
                <CheckCircleIcon size={20} />
                <span>Shop Now</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
